import { withLazyFallback } from 'lib/hoc/withLazyFallback';

const NotFound = withLazyFallback(() => import('components/NotFound'));
const AdminPatientsLogs = withLazyFallback(() => import('components/admin/pages/Patients/Logs'));
const AdminPatientBasicInfo = withLazyFallback(
  () => import('components/admin/pages/Patients/PatientBasicInfo')
);
const AdminPatients = withLazyFallback(
  () => import('components/admin/pages/Patients/PatientsTable')
);
const AdminPatientsTransactions = withLazyFallback(
  () => import('components/admin/pages/Patients/Transaction/Transactions')
);
const PatientProfile = withLazyFallback(() => import('components/admin/pages/Patients/profile'));

const ADMIN_PATIENTS = [
  {
    path: 'patients',
    element: <AdminPatients />,
    children: [
      {
        path: ':id',
        element: <PatientProfile />,
        children: [
          { path: '', element: <AdminPatientBasicInfo /> },
          { path: 'logs', element: <AdminPatientsLogs /> },
          { path: 'transactions', element: <AdminPatientsTransactions /> },
          { path: '*', element: <NotFound /> }
        ]
      },
      { path: '*', element: <NotFound /> }
    ]
  }
];

export default ADMIN_PATIENTS;
